import { useRef, useState, useEffect, useContext, useLayoutEffect } from 'react'
import { CommandBarButton, IconButton, Dialog, DialogType, Stack } from '@fluentui/react'
import { SquareRegular, ShieldLockRegular, ErrorCircleRegular, Info16Regular} from '@fluentui/react-icons'

//import SNAImage from '../../assets/SNA-best-res.png';
//import BPM6Image from '../../assets/BPM6-best-res.png';
import BPM7Image from '../../assets/bpm7_draft.png';
import SNAImage25 from '../../assets/SNA-best-res.png';
import FSIImage from '../../assets/Financial-Soundness-best-res.png';
import GFSImage from '../../assets/finance-statistics-manual-2014-best-res.png';

import { useOutletContext } from 'react-router-dom'; // added for new dropdown functionality (STA Chatbot)
import DocumentDropdown from "./DocumentDropdown";

import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import uuid from 'react-uuid'
import { isEmpty } from 'lodash'
import DOMPurify from 'dompurify'
//import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
//import { nord } from 'react-syntax-highlighter/dist/esm/styles/prism'
//import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
//import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs'

import hljs from 'highlight.js/lib/core'
import javascript from 'highlight.js/lib/languages/javascript'
import python from 'highlight.js/lib/languages/python'
import 'highlight.js/styles/docco.css'

import styles from './Chat.module.css'
import Contoso from '../../assets/Contoso.svg'
import { XSSAllowTags } from '../../constants/sanatizeAllowables'

hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('python', python)

import {
  ChatMessage,
  ConversationRequest,
  conversationApi,
  Citation,
  ToolMessageContent,
  AzureSqlServerExecResults,
  ChatResponse,
  getUserInfo,
  Conversation,
  historyGenerate,
  historyUpdate,
  historyClear,
  ChatHistoryLoadingState,
  CosmosDBStatus,
  ErrorMessage,
  ExecResults,
} from "../../api";
import { Answer } from "../../components/Answer";
import { QuestionInput } from "../../components/QuestionInput";
import { ChatHistoryPanel } from "../../components/ChatHistory/ChatHistoryPanel";
import { AppStateContext } from "../../state/AppProvider";
import { useBoolean } from "@fluentui/react-hooks";

import { loadFrontendConfig, frontendSettings  } from "../../api/api";

const stripLinksComponent = {
  a: ({ node, children }: { node: any; children: React.ReactNode }) => <>{children}</>
}

function stripMarkdownLinksKeepText(input: string): string {
  // Linear-time scan: converts "[text](url)" -> "text"
  var out = ''
  for (let i = 0; i < input.length; i++) {
    if (input[i] === '[') {
      const closeText = input.indexOf(']', i + 1)
      if (closeText !== -1 && input[closeText + 1] === '(') {
        const closeUrl = input.indexOf(')', closeText + 2)
        if (closeUrl !== -1) {
          out += input.slice(i + 1, closeText)
          i = closeUrl
          continue
        }
      }
    }
    out += input[i]
  }
  return out
}

function cleanup_string(str: string): string {
  var temp = str.replaceAll("\n","<br/><br/>")
  
  // Remove <a> tags but keep their inner text
  temp = temp.replace(/<a\b[^>]*>(.*?)<\/a>/gi, '$1');
  
  // Remove Markdown-style links [text](url) -> text
  temp = stripMarkdownLinksKeepText(temp);
  return temp
}

const enum messageStatus {
  NotRunning = 'Not Running',
  Processing = 'Processing',
  Done = 'Done'
}

const documentNameMapping: Record<string, string> = {
  "Balance of Payments and International Investment Positions Manual, seventh edition (BPM7).pdf": "Balance of Payments and International Investment Positions Manual (BPM 7)",
  "2025_SNA_Combined_5February2025.pdf": "System of National Accounts (2025)",
  "Consumer Price Index Manual (2020).pdf": "Consumer Price index Manual (2020)",
  "Financial Soundness Indicators Compilation Guide (2019).pdf": "Financial Soundness Indicators Compilation Guide (2019)",
  "Quarterly National Accounts Manual (2017).pdf": "Quarterly National Accounts Manual (2017)",
  "Monetary and Financial Statistics Manual and Compilation Guide (2016).pdf": "Monetary and Financial Statistics Manual and Compilation Guide (2016)",
  "Handbook on Securities Statistics.pdf": "Handbook on Securities Statistics",
  "Government Finance Statistics Manual (2014).pdf": "Government Financial Statistics Manual (2014)",
  "System of Environmental and Economic Accounting – Central Framework (2012).pdf": "System of Environmental and Economic Account - Central Famework (2012)",  
  "Producer Price Index Manual (2010).pdf": "Producer Price Index Manual (2010)",
  "European System of Accounts (2010).pdf": "European System of Accounts (2010)",
  "Balance of Payments and International Investment Position Manual (BPM 6).pdf": "Balance of Payments and International Investment Position Manual (BPM 6)",
  "System of National Accounts (2008).pdf": "System of National Accounts (2008)",
  "Monetary and Financial Statistics Manual and Compilation Guide (2008).pdf": "Monetary and Financial Statistics Manual and Compilation Guide (2008)",
  "Government Finance Statistics Manual (2001).pdf": "Government Financial Statistics Manual (2001)",
  "Balance of Payments Manual, fifth edition (BPM 5).pdf": "Balance of Payments (BPM 5)",
  "System of National Accounts (1993).pdf": "System of National Accounts (1993)",

  "CPC_Ver_3_Intro_2024.pdf": "CPC Ver.3.0 2024",
  "CPC_Ver_Explanatory_Notes_2025.pdf": "CPC Ver.3.0 Explanatory Notes",
  "ISIC5_Intro_2024.pdf": "ISIC Rev.5",
  "ISIC5_Explantory_Notes_2024.pdf": "ISIC Explanatory Notes Rev.5",
  "SEEA_EA_2024.pdf": "SEEA Ecosystem Accounting 2024",
  "SEEA AFF_2020.pdf": "SEEA Agriculture, Forestry and Fisheries 2020",
  "SEEA-Energy_2019.pdf": "SEEA Energy 2020",
  "SEEA-Water_2012.pdf": "SEEA Water 2012",
  "NEW_External_Debt_Statistics-Guide_for_Compilers_and_Users.pdf": "External Debt Statistics Guide for Compilers and Users (2024)"
  // Add more mappings as needed
};

function extractYear(value: string | undefined): number | undefined {
  if (!value) return undefined;
  const match = value.match(/\b(19|20)\d{2}\b/);
  if (!match) return undefined;
  const year = Number(match[0]);
  return Number.isFinite(year) ? year : undefined;
}

const documentNameMappingOrder = Object.keys(documentNameMapping)
  .slice()
  .sort((a, b) => {
    const aYear = extractYear(a) ?? extractYear(documentNameMapping[a]) ?? 0;
    const bYear = extractYear(b) ?? extractYear(documentNameMapping[b]) ?? 0;
    if (aYear !== bYear) return bYear - aYear;

    const aName = (documentNameMapping[a] || a).toLowerCase();
    const bName = (documentNameMapping[b] || b).toLowerCase();
    return aName.localeCompare(bName);
  });

const Chat = () => {
  
  useEffect(() => {
    async function init() {
      await loadFrontendConfig();              //  Load key first
      //const settings = await frontendSettings();  //  Then make the request with correct headers
      //console.log("Frontend settings:", settings);
    }
  
    init();
  }, []);

  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state.frontendSettings?.ui
  const AUTH_ENABLED = appStateContext?.state.frontendSettings?.auth_enabled
  const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [showLoadingMessage, setShowLoadingMessage] = useState<boolean>(false)
  const [activeCitation, setActiveCitation] = useState<Citation>()
  const [isCitationPanelOpen, setIsCitationPanelOpen] = useState<boolean>(false)
  const [isIntentsPanelOpen, setIsIntentsPanelOpen] = useState<boolean>(false)
  const abortFuncs = useRef([] as AbortController[])
  const [showAuthMessage, setShowAuthMessage] = useState<boolean | undefined>()
  const [messages, setMessages] = useState<ChatMessage[]>([])
  const [execResults, setExecResults] = useState<ExecResults[]>([])
  const [processMessages, setProcessMessages] = useState<messageStatus>(messageStatus.NotRunning)
  const [clearingChat, setClearingChat] = useState<boolean>(false)
  const [hideErrorDialog, { toggle: toggleErrorDialog }] = useBoolean(true)
  const [errorMsg, setErrorMsg] = useState<ErrorMessage | null>()
  const [logo, setLogo] = useState('')
  const [answerId, setAnswerId] = useState<string>('')
  const [isOpen, setIsOpen] = useState(false);
  const { documents } = useOutletContext<{ documents: string[] }>();
  const [isDropdownExpanded, setIsDropdownExpanded] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isDocSelectorMinimized, setIsDocSelectorMinimized] = useState<boolean>(false);

  //Dropdown Effect (STA Chatbot)
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownExpanded(false); // Close dropdown only when clicking outside
      }
    }
  
    if (isDropdownExpanded) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownExpanded]);
      const [selectedDocuments, setSelectedDocuments] = useState<string[]>([]);
      const [cleanedDocumentNames, setCleanedDocumentNames] = useState<string[]>([]);  // UI-friendly names
      
      const handleDocumentChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
          const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
          setSelectedDocuments(selectedValues);  // Store original names for the backend
          setCleanedDocumentNames(selectedValues.map(doc => documentNameMapping[doc] || doc)); // Display in UI 
      };
  //End of new code

  const errorDialogContentProps = {
    type: DialogType.close,
    title: errorMsg?.title,
    closeButtonAriaLabel: 'Close',
    subText: errorMsg?.subtitle
  }

  const modalProps = {
    titleAriaId: 'labelId',
    subtitleAriaId: 'subTextId',
    isBlocking: true,
    styles: { main: { maxWidth: 450 } }
  }

  const [ASSISTANT, TOOL, ERROR] = ['assistant', 'tool', 'error']
  const NO_CONTENT_ERROR = 'No content in messages object.'

  useEffect(() => {
    if (
      appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.Working &&
      appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured &&
      appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Fail &&
      hideErrorDialog
    ) {
      let subtitle = `${appStateContext.state.isCosmosDBAvailable.status}. Please contact the site administrator.`
      setErrorMsg({
        title: 'Chat history is not enabled',
        subtitle: subtitle
      })
      toggleErrorDialog()
    }
  }, [appStateContext?.state.isCosmosDBAvailable])

  const handleErrorDialogClose = () => {
    toggleErrorDialog()
    setTimeout(() => {
      setErrorMsg(null)
    }, 500)
  }

  useEffect(() => {
    if (!appStateContext?.state.isLoading) {
      setLogo(ui?.chat_logo || ui?.logo || Contoso)
    }
  }, [appStateContext?.state.isLoading])

  useEffect(() => {
    setIsLoading(appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading)
  }, [appStateContext?.state.chatHistoryLoadingState])

  const getUserInfoList = async () => {
    if (!AUTH_ENABLED) {
      setShowAuthMessage(false)
      return
    }
    const userInfoList = await getUserInfo()
    if (userInfoList.length === 0 && window.location.hostname !== '127.0.0.1') {
      setShowAuthMessage(true)
    } else {
      setShowAuthMessage(false)
    }
  }

  let assistantMessage = {} as ChatMessage
  let toolMessage = {} as ChatMessage
  let assistantContent = ''

  useEffect(() => parseExecResults(execResults), [execResults])

  const parseExecResults = (exec_results_: any): void => {
    if (exec_results_ == undefined) return
    const exec_results = exec_results_.length === 2 ? exec_results_ : exec_results_.splice(2)
    appStateContext?.dispatch({ type: 'SET_ANSWER_EXEC_RESULT', payload: { answerId: answerId, exec_result: exec_results } })
  }

  const processResultMessage = (resultMessage: ChatMessage, userMessage: ChatMessage, conversationId?: string) => {
    if (typeof resultMessage.content === "string" && resultMessage.content.includes('all_exec_results')) {
        const parsedExecResults = JSON.parse(resultMessage.content) as AzureSqlServerExecResults;
        setExecResults(parsedExecResults.all_exec_results);
        assistantMessage.context = JSON.stringify({
            all_exec_results: parsedExecResults.all_exec_results
        });
    }
    if (resultMessage.role === ASSISTANT) {
        setAnswerId(resultMessage.id);
        assistantContent += resultMessage.content;

        assistantMessage = { ...assistantMessage, ...resultMessage };
        assistantMessage.content = assistantContent.trim();

        //  Ensure `filter_applied` persists across messages
        if (resultMessage.filter_applied) {
            assistantMessage.filter_applied = resultMessage.filter_applied;
        }

        //  Ensure `filter_applied` is appended only at the END of the full assistant response
        if (assistantMessage.filter_applied && !assistantMessage.content.includes("**Filter Applied:**")) {
            assistantMessage.content += `\n\n**Filter Applied:** ${assistantMessage.filter_applied}`;
        }

        if (resultMessage.context) {
          toolMessage = {
            id: uuid(),
            role: TOOL,
            content: resultMessage.context,
            date: new Date().toISOString()
          }
        }
      }

    if (resultMessage.role === TOOL) {
      toolMessage = resultMessage
    }

    if (!conversationId) {
      isEmpty(toolMessage)
        ? setMessages([...messages, userMessage, assistantMessage])
        : setMessages([...messages, userMessage, toolMessage, assistantMessage])
    } else {
      isEmpty(toolMessage)
        ? setMessages([...messages, assistantMessage])
        : setMessages([...messages, toolMessage, assistantMessage])
    }
  }

  const makeApiRequestWithoutCosmosDB = async (question: ChatMessage["content"], conversationId?: string) => {
    setIsLoading(true)
    setShowLoadingMessage(true)
    const abortController = new AbortController()
    abortFuncs.current.unshift(abortController)

    const uniqueDocuments = Array.from(new Set(selectedDocuments.map(doc => doc.trim())));
    
    const questionContent = typeof question === 'string' ? question : [{ type: "text", text: question[0].text }, { type: "image_url", image_url: { url: question[1].image_url.url } }]
    question = typeof question !== 'string' && question[0]?.text?.length > 0 ? question[0].text : question
     
    const userMessage: ChatMessage = {
      id: uuid(),
      role: 'user',
      content: questionContent as string,
      date: new Date().toISOString()
    }

    let conversation: Conversation | null | undefined
    if (!conversationId) {
      conversation = {
        id: conversationId ?? uuid(),
        title: question as string,
        messages: [userMessage],
        date: new Date().toISOString()
      }
    } else {
      conversation = appStateContext?.state?.currentChat
      if (!conversation) {
        console.error('Conversation not found.')
        setIsLoading(false)
        setShowLoadingMessage(false)
        abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
        return
      } else {
        conversation.messages.push(userMessage)
      }
    }

    appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: conversation })
    setMessages(conversation.messages)

    //(STA Chatbot) Adding new filter (metadata_storage)
    // Deduplicate selected documents before applying filter
    
     //  Ensure filter is set correctly
     const filterCondition = uniqueDocuments.length > 0 
        ? uniqueDocuments.map(doc => `filepath eq '${doc}'`).join(" or ") 
        : undefined;

     const request: ConversationRequest = {
          messages: [userMessage],
          filter: filterCondition !== undefined ? filterCondition : "", // Ensure empty string if undefined
          selectedDocuments: uniqueDocuments.length > 0 ? uniqueDocuments : []
     };
    
    let result = {} as ChatResponse
    
    //(STA Chatbot) Added array with Selected document
    try {
      //const response = await conversationApi(request, abortController.signal)
      const response = await conversationApi(request, abortController.signal, selectedDocuments ?? undefined);
      
      if (response?.body) {
        const reader = response.body.getReader()

        let runningText = ''
        while (true) {
          setProcessMessages(messageStatus.Processing)
          const { done, value } = await reader.read()
          if (done) break

          var text = new TextDecoder('utf-8').decode(value)
          const objects = text.split('\n')
          objects.forEach(obj => {
            try {
              if (obj !== '' && obj !== '{}') {
                runningText += obj
                result = JSON.parse(runningText)

                if (result.choices?.length > 0) {
                  result.choices[0].messages.forEach(msg => {
                    msg.id = result.id
                    msg.date = new Date().toISOString()
                  })
                  if (result.choices[0].messages?.some(m => m.role === ASSISTANT)) {
                    setShowLoadingMessage(false)
                  }
                  result.choices[0].messages.forEach(resultObj => {
                    processResultMessage(resultObj, userMessage, conversationId)
                  })
                } else if (result.error) {
                  throw Error(result.error)
                }
                runningText = ''
              }
            } catch (e) {
              if (!(e instanceof SyntaxError)) {
                console.error(e)
                throw e
              } else {
                console.log('Incomplete message. Continuing...')
              }
            }
          })
        }
        conversation.messages.push(toolMessage, assistantMessage)
        appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: conversation })
        setMessages([...messages, toolMessage, assistantMessage])
      }
    } catch (e) {
      if (!abortController.signal.aborted) {
        let errorMessage =
          'An error occurred. Please try again. If the problem persists, please contact the site administrator.'

          //(STA Chatbot) Additional logs - comment out in prod.
          console.error('Chat API Error Details:', {
            error: e,
            result: result,
            resultError: result.error,
            timestamp: new Date().toISOString()
          });
          //End of statement 
          
        if (result.error?.message) {
          errorMessage = result.error.message
        } else if (typeof result.error === 'string') {
          errorMessage = result.error
        }

        errorMessage = parseErrorMessage(errorMessage)

        let errorChatMsg: ChatMessage = {
          id: uuid(),
          role: ERROR,
          content: errorMessage,
          date: new Date().toISOString()
        }
        conversation.messages.push(errorChatMsg)
        appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: conversation })
        setMessages([...messages, errorChatMsg])
      } else {
        setMessages([...messages, userMessage])
      }
    } finally {
      setIsLoading(false)
      setShowLoadingMessage(false)
      abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
      setProcessMessages(messageStatus.Done)
    }

    return abortController.abort()
  }

  const makeApiRequestWithCosmosDB = async (question: ChatMessage["content"], conversationId?: string) => {
    setIsLoading(true)
    setShowLoadingMessage(true)
    const abortController = new AbortController()
    abortFuncs.current.unshift(abortController)
  
    const DEFAULT_DOCUMENTS = ["2025_SNA_Combined_5February2025.pdf",
                               "Balance of Payments and International Investment Positions Manual, seventh edition (BPM7).pdf",
                               "Consumer Price Index Manual (2020).pdf",
                               "Producer Price Index Manual (2010).pdf",
                               "European System of Accounts (2010).pdf",
                               "Financial Soundness Indicators Compilation Guide (2019).pdf",
                               "Government Finance Statistics Manual (2014).pdf",
                               "Handbook on Securities Statistics.pdf",
                               "Monetary and Financial Statistics Manual and Compilation Guide (2016).pdf",
                               "Quarterly National Accounts Manual (2017).pdf",
                               "System of Environmental and Economic Accounting - Central Framework (2012).pdf",
                               "CPC_Ver_3_Intro_2024.pdf",
                               "CPC_Ver_Explanatory_Notes_2025.pdf",
                               "ISIC5_Intro_2024.pdf",
                               "ISIC5_Explantory_Notes_2024.pdf",
                               "SEEA_EA_2024.pdf",
                               "SEEA AFF_2020.pdf",
                               "SEEA-Energy_2019.pdf",
                               "SEEA-Water_2012.pdf",
                               "NEW_External_Debt_Statistics-Guide_for_Compilers_and_Users.pdf"];
                               
    const uniqueDocuments = selectedDocuments.length > 0 
      ? Array.from(new Set(selectedDocuments.map(doc => doc.trim()))) 
      : DEFAULT_DOCUMENTS;

    const filterCondition = uniqueDocuments.map(doc => `filepath eq '${doc}'`).join(" or ");
    
    const questionContent = typeof question === 'string' ? question : [{ type: "text", text: question[0].text }, { type: "image_url", image_url: { url: question[1].image_url.url } }]
    question = typeof question !== 'string' && question[0]?.text?.length > 0 ? question[0].text : question

    const userMessage: ChatMessage = {
      id: uuid(),
      role: 'user',
      content: questionContent as string,
      date: new Date().toISOString()
    }

    
    let request: ConversationRequest
    let conversation;
    
    if (conversationId) {
      conversation = appStateContext?.state?.chatHistory?.find(conv => conv.id === conversationId)
      if (!conversation) {
        console.error('Conversation not found.')
        setIsLoading(false)
        setShowLoadingMessage(false)
        abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
        return
      } else {
        conversation.messages.push(userMessage)
        //  Ensure the filter and selectedDocuments are included (Update 3)
        request = {
          messages: [...conversation.messages.filter(answer => answer.role !== ERROR)],
          filter: filterCondition,  //  Ensure filter is always included
          selectedDocuments: uniqueDocuments.length > 0 ? uniqueDocuments : undefined  // Ensuring selected documents are passed
        }
      }
    } else {
      request = {
        messages: [userMessage].filter(answer => answer.role !== ERROR),
        filter: filterCondition,  // Ensuring filter is passed
        selectedDocuments: uniqueDocuments.length > 0 ? uniqueDocuments : undefined  //  Ensuring selected documents are passed
      }
      setMessages(request.messages)
    }

    let result = {} as ChatResponse
    var errorResponseMessage = 'Please try again. If the problem persists, please contact the site administrator.'
    try {
      const response = conversationId
        ? await historyGenerate(request, abortController.signal, conversationId)
        : await historyGenerate(request, abortController.signal)
      if (!response?.ok) {
        const responseJson = await response.json()
        errorResponseMessage =
          responseJson.error === undefined ? errorResponseMessage : parseErrorMessage(responseJson.error)
        let errorChatMsg: ChatMessage = {
          id: uuid(),
          role: ERROR,
          content: `There was an error generating a response. Chat history can't be saved at this time. ${errorResponseMessage}`,
          date: new Date().toISOString()
        }
        let resultConversation
        if (conversationId) {
          resultConversation = appStateContext?.state?.chatHistory?.find(conv => conv.id === conversationId)
          if (!resultConversation) {
            console.error('Conversation not found.')
            setIsLoading(false)
            setShowLoadingMessage(false)
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
            return
          }
          resultConversation.messages.push(errorChatMsg)
        } else {
          setMessages([...messages, userMessage, errorChatMsg])
          setIsLoading(false)
          setShowLoadingMessage(false)
          abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
          return
        }
        appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: resultConversation })
        setMessages([...resultConversation.messages])
        return
      }
      if (response?.body) {
        const reader = response.body.getReader()

        let runningText = ''
        while (true) {
          setProcessMessages(messageStatus.Processing)
          const { done, value } = await reader.read()
          if (done) break

          var text = new TextDecoder('utf-8').decode(value)
          
          const objects = text.split('\n')
          objects.forEach(obj => {
            try {
              if (obj !== '' && obj !== '{}') {
                runningText += obj
                result = JSON.parse(runningText)
                if (!result.choices?.[0]?.messages?.[0].content) {
                  errorResponseMessage = NO_CONTENT_ERROR
                  throw Error()
                }
                if (result.choices?.length > 0) {
                  result.choices[0].messages.forEach(msg => {
                    msg.id = result.id
                    msg.date = new Date().toISOString()
                  })
                  if (result.choices[0].messages?.some(m => m.role === ASSISTANT)) {
                    setShowLoadingMessage(false)
                  }
                  result.choices[0].messages.forEach(resultObj => {
                    processResultMessage(resultObj, userMessage, conversationId)
                  })
                }
                runningText = ''
              } else if (result.error) {
                throw Error(result.error)
              }
            } catch (e) {
              if (!(e instanceof SyntaxError)) {
                console.error(e)
                throw e
              } else {
                console.log('Incomplete message. Continuing...')
              }
            }
          })
        }

        let resultConversation
        if (conversationId) {
          resultConversation = appStateContext?.state?.chatHistory?.find(conv => conv.id === conversationId)
          if (!resultConversation) {
            console.error('Conversation not found.')
            setIsLoading(false)
            setShowLoadingMessage(false)
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
            return
          }
          isEmpty(toolMessage)
            ? resultConversation.messages.push(assistantMessage)
            : resultConversation.messages.push(toolMessage, assistantMessage)
        } else {
          resultConversation = {
            id: result.history_metadata.conversation_id,
            title: result.history_metadata.title,
            messages: [userMessage],
            date: result.history_metadata.date
          }
          isEmpty(toolMessage)
            ? resultConversation.messages.push(assistantMessage)
            : resultConversation.messages.push(toolMessage, assistantMessage)
        }
        if (!resultConversation) {
          setIsLoading(false)
          setShowLoadingMessage(false)
          abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
          return
        }
        appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: resultConversation })
        isEmpty(toolMessage)
          ? setMessages([...messages, assistantMessage])
          : setMessages([...messages, toolMessage, assistantMessage])
      }
    } catch (e) {
      if (!abortController.signal.aborted) {
        let errorMessage = `An error occurred. ${errorResponseMessage}`
        if (result.error?.message) {
          errorMessage = result.error.message
        } else if (typeof result.error === 'string') {
          errorMessage = result.error
        }

        errorMessage = parseErrorMessage(errorMessage)

        let errorChatMsg: ChatMessage = {
          id: uuid(),
          role: ERROR,
          content: errorMessage,
          date: new Date().toISOString()
        }
        let resultConversation
        if (conversationId) {
          resultConversation = appStateContext?.state?.chatHistory?.find(conv => conv.id === conversationId)
          if (!resultConversation) {
            console.error('Conversation not found.')
            setIsLoading(false)
            setShowLoadingMessage(false)
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
            return
          }
          resultConversation.messages.push(errorChatMsg)
        } else {
          if (!result.history_metadata) {
            console.error('Error retrieving data.', result)
            let errorChatMsg: ChatMessage = {
              id: uuid(),
              role: ERROR,
              content: errorMessage,
              date: new Date().toISOString()
            }
            setMessages([...messages, userMessage, errorChatMsg])
            setIsLoading(false)
            setShowLoadingMessage(false)
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
            return
          }
          resultConversation = {
            id: result.history_metadata.conversation_id,
            title: result.history_metadata.title,
            messages: [userMessage],
            date: result.history_metadata.date
          }
          resultConversation.messages.push(errorChatMsg)
        }
        if (!resultConversation) {
          setIsLoading(false)
          setShowLoadingMessage(false)
          abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
          return
        }
        appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: resultConversation })
        setMessages([...messages, errorChatMsg])
      } else {
        setMessages([...messages, userMessage])
      }
    } finally {
      setIsLoading(false)
      setShowLoadingMessage(false)
      abortFuncs.current = abortFuncs.current.filter(a => a !== abortController)
      setProcessMessages(messageStatus.Done)
    }
    return abortController.abort()
  }

  const clearChat = async () => {
    setClearingChat(true)
    if (appStateContext?.state.currentChat?.id && appStateContext?.state.isCosmosDBAvailable.cosmosDB) {
      let response = await historyClear(appStateContext?.state.currentChat.id)
      if (!response.ok) {
        setErrorMsg({
          title: 'Error clearing current chat',
          subtitle: 'Please try again. If the problem persists, please contact the site administrator.'
        })
        toggleErrorDialog()
      } else {
        appStateContext?.dispatch({
          type: 'DELETE_CURRENT_CHAT_MESSAGES',
          payload: appStateContext?.state.currentChat.id
        })
        appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY', payload: appStateContext?.state.currentChat })
        setActiveCitation(undefined)
        setIsCitationPanelOpen(false)
        setIsIntentsPanelOpen(false)
        setMessages([])
        setSelectedDocuments([]) // <-- Reset the dropdown selections
        setCleanedDocumentNames([])
      }
    }
    setClearingChat(false)
  }

  const tryGetRaiPrettyError = (errorMessage: string) => {
    try {
      // Using a regex to extract the JSON part that contains "innererror"
      const match = errorMessage.match(/'innererror': ({.*})\}\}/)
      if (match) {
        // Replacing single quotes with double quotes and converting Python-like booleans to JSON booleans
        const fixedJson = match[1]
          .replace(/'/g, '"')
          .replace(/\bTrue\b/g, 'true')
          .replace(/\bFalse\b/g, 'false')
        const innerErrorJson = JSON.parse(fixedJson)
        let reason = ''
        // Check if jailbreak content filter is the reason of the error
        const jailbreak = innerErrorJson.content_filter_result.jailbreak
        if (jailbreak.filtered === true) {
          reason = 'Jailbreak'
        }

        // Returning the prettified error message
        if (reason !== '') {
          return (
            'The content of your question may have triggered a safety filter. Please try rephrasing it or contact support if the issue persists. ' +
            //'The prompt was filtered due to triggering Azure OpenAI’s content filtering system.\n' +
            //'Reason: This prompt contains content flagged as ' +
            //reason +
            //'\n\n' +
            'Please modify your prompt and retry. Learn more: https://go.microsoft.com/fwlink/?linkid=2198766'
          )
        }
      }
    } catch (e) {
      console.error('Failed to parse the error:', e)
    }
    return errorMessage
  }

  const parseErrorMessage = (errorMessage: string) => {
    let errorCodeMessage = errorMessage.substring(0, errorMessage.indexOf('-') + 1)
    const innerErrorCue = "{\\'error\\': {\\'message\\': "
    if (errorMessage.includes(innerErrorCue)) {
      try {
        let innerErrorString = errorMessage.substring(errorMessage.indexOf(innerErrorCue))
        if (innerErrorString.endsWith("'}}")) {
          innerErrorString = innerErrorString.substring(0, innerErrorString.length - 3)
        }
        innerErrorString = innerErrorString.replaceAll("\\'", "'")
        let newErrorMessage = errorCodeMessage + ' ' + innerErrorString
        errorMessage = newErrorMessage
      } catch (e) {
        console.error('Error parsing inner error message: ', e)
      }
    }

    return tryGetRaiPrettyError(errorMessage)
  }

  const newChat = () => {
    setProcessMessages(messageStatus.Processing)
    setMessages([])
    setIsCitationPanelOpen(false)
    setIsIntentsPanelOpen(false)
    setActiveCitation(undefined)
    setSelectedDocuments([])
    setCleanedDocumentNames([])
    appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: null })
    setProcessMessages(messageStatus.Done)
  }

  const stopGenerating = () => {
    abortFuncs.current.forEach(a => a.abort())
    setShowLoadingMessage(false)
    setIsLoading(false)
  }

  useEffect(() => {
    if (appStateContext?.state.currentChat) {
      setMessages(appStateContext.state.currentChat.messages)
    } else {
      setMessages([])
    }
  }, [appStateContext?.state.currentChat])

  useLayoutEffect(() => {
    const saveToDB = async (messages: ChatMessage[], id: string) => {
      const response = await historyUpdate(messages, id)
      return response
    }

    if (appStateContext && appStateContext.state.currentChat && processMessages === messageStatus.Done) {
      if (appStateContext.state.isCosmosDBAvailable.cosmosDB) {
        if (!appStateContext?.state.currentChat?.messages) {
          console.error('Failure fetching current chat state.')
          return
        }
        const noContentError = appStateContext.state.currentChat.messages.find(m => m.role === ERROR)

        if (!noContentError) {
          saveToDB(appStateContext.state.currentChat.messages, appStateContext.state.currentChat.id)
            .then(res => {
              if (!res.ok) {
                let errorMessage =
                  "An error occurred. Answers can't be saved at this time. If the problem persists, please contact the site administrator."
                let errorChatMsg: ChatMessage = {
                  id: uuid(),
                  role: ERROR,
                  content: errorMessage,
                  date: new Date().toISOString()
                }
                if (!appStateContext?.state.currentChat?.messages) {
                  let err: Error = {
                    ...new Error(),
                    message: 'Failure fetching current chat state.'
                  }
                  throw err
                }
                setMessages([...appStateContext?.state.currentChat?.messages, errorChatMsg])
              }
              return res as Response
            })
            .catch(err => {
              console.error('Error: ', err)
              let errRes: Response = {
                ...new Response(),
                ok: false,
                status: 500
              }
              return errRes
            })
        }
      } else {
      }
      appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY', payload: appStateContext.state.currentChat })
      setMessages(appStateContext.state.currentChat.messages)
      setProcessMessages(messageStatus.NotRunning)
    }
  }, [processMessages])

  useEffect(() => {
    if (AUTH_ENABLED !== undefined) getUserInfoList()
  }, [AUTH_ENABLED])

  useLayoutEffect(() => {
    chatMessageStreamEnd.current?.scrollIntoView({ behavior: 'smooth' })
  }, [showLoadingMessage, processMessages])

  const onShowCitation = (citation: Citation) => {
    setActiveCitation(citation)
    setIsCitationPanelOpen(true)
  }

  const onShowExecResult = (answerId: string) => {
    setIsIntentsPanelOpen(true)
  }

  const onViewSource = (citation: Citation) => {
    if (citation.url && !citation.url.includes('blob.core')) {
      window.open(citation.url, '_blank')
    }
  }

  const findNearestToolMessage = (msgs: ChatMessage[], assistantIndex: number): ChatMessage | null => {
    for (let i = assistantIndex - 1; i >= 0; i--) {
      const m = msgs[i]
      if (!m) continue
      if (m.role === 'tool') return m
      // Stop at the first boundary so we don't accidentally grab citations
      // from a previous user turn / assistant answer.
      if (m.role === 'user' || m.role === 'assistant') break
    }
    return null
  }

  const findLastAssistantIndex = (msgs: ChatMessage[]): number => {
    for (let i = msgs.length - 1; i >= 0; i--) {
      if (msgs[i]?.role === 'assistant') return i
    }
    return -1
  }

  const parseCitationFromMessage = (message?: ChatMessage | null) => {
    if (message?.role && message?.role === 'tool' && typeof message?.content === "string") {
      try {
        const toolMessage = JSON.parse(message.content) as ToolMessageContent
        return toolMessage.citations
      } catch {
        return []
      }
    }
    return []
  }

  const parsePlotFromMessage = (message?: ChatMessage | null) => {
    if (message?.role && message?.role === "tool" && typeof message?.content === "string") {
      try {
        const execResults = JSON.parse(message.content) as AzureSqlServerExecResults;
        const codeExecResult = execResults.all_exec_results.at(-1)?.code_exec_result;

        if (codeExecResult === undefined) {
          return null;
        }
        return codeExecResult.toString();
      }
      catch {
        return null;
      }
      // const execResults = JSON.parse(message.content) as AzureSqlServerExecResults;
      // return execResults.all_exec_results.at(-1)?.code_exec_result;
    }
    return null;
  }

  const disabledButton = () => {
    return (
      isLoading ||
      (messages && messages.length === 0) ||
      clearingChat ||
      appStateContext?.state.chatHistoryLoadingState === ChatHistoryLoadingState.Loading
    )
  }

  const [pendingQuestion, setPendingQuestion] = useState<string | null>(null);
  const [isStatsChatModalOpen, setIsStatsChatModalOpen] = useState(false);
  const [showSupportFallbackMessage, setShowSupportFallbackMessage] = useState(false);
  const [supportEmailCopied, setSupportEmailCopied] = useState(false);
  const getSupportEmail = () =>
    String.fromCharCode(
      116, 97, 108, 107, 50, 109, 97, 110, 117, 97, 108, 115, 64, 105, 109, 102, 46, 111, 114, 103
    );

  const handleContactSupportClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const supportEmail = getSupportEmail();
    setShowSupportFallbackMessage(false);
    setSupportEmailCopied(false);

    let pageHidden = false;
    const markHidden = () => {
      pageHidden = true;
    };

    window.addEventListener('blur', markHidden, { once: true });
    document.addEventListener('visibilitychange', markHidden, { once: true });

    window.location.href = `mailto:${supportEmail}`;

    window.setTimeout(() => {
      if (!pageHidden && document.visibilityState === 'visible') {
        setShowSupportFallbackMessage(true);
      }
    }, 1200);
  };

  const handleCopySupportEmail = async () => {
    try {
      await navigator.clipboard.writeText(getSupportEmail());
      setSupportEmailCopied(true);
    } catch (error) {
      console.error('Failed to copy support email:', error);
      setSupportEmailCopied(false);
    }
  };

  const handleQuickQuestion = (question: string) => {
    if (!isLoading) {
      // Step 1: Clear the filter selections
      setSelectedDocuments([]);
      setCleanedDocumentNames([]);

      // Step 2: Store the question in state and wait for filters to reset
      setPendingQuestion(question);
    }
  };

  // Step 3: Detect when filters are cleared and send the request
  useEffect(() => {
    if (pendingQuestion !== null && selectedDocuments.length === 0) {
      if (appStateContext?.state.isCosmosDBAvailable?.cosmosDB) {
        makeApiRequestWithCosmosDB(pendingQuestion);
      } else {
        makeApiRequestWithoutCosmosDB(pendingQuestion);
      }
      setPendingQuestion(null); // Clear pending question
    }
  }, [selectedDocuments, pendingQuestion]); // Trigger when selectedDocuments update

  return (
    <div className={styles.container} role="main">
      {showAuthMessage ? (
        <Stack className={styles.chatEmptyState}>
          <ShieldLockRegular
            className={styles.chatIcon}
            style={{ color: 'darkorange', height: '200px', width: '200px' }}
          />
          <h1 className={styles.chatEmptyStateTitle}>Authentication Not Configured</h1>
          <h2 className={styles.chatEmptyStateSubtitle}>
            This app does not have authentication configured. Please add an identity provider by finding your app in the{' '}
            <a href="https://portal.azure.com/" target="_blank">
              Azure Portal
            </a>
            and following{' '}
            <a
              href="https://learn.microsoft.com/en-us/azure/app-service/scenario-secure-app-authentication-app-service#3-configure-authentication-and-authorization"
              target="_blank">
              these instructions
            </a>
            .
          </h2>
          <h2 className={styles.chatEmptyStateSubtitle} style={{ fontSize: '20px' }}>
            <strong>Authentication configuration takes a few minutes to apply. </strong>
          </h2>
          <h2 className={styles.chatEmptyStateSubtitle} style={{ fontSize: '20px' }}>
            <strong>If you deployed in the last 10 minutes, please wait and reload the page after 10 minutes.</strong>
          </h2>
        </Stack>
      ) : (
        <Stack horizontal className={styles.chatRoot}>
          <div className={styles.chatContainer}>
            {!messages || messages.length < 1 ? (
              <Stack className={styles.chatEmptyState}>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <a href="https://unstats.un.org/unsd/nationalaccount/SNAUpdate/2025/2025_SNA_Combined.pdf" target="_blank" rel="noopener noreferrer">
                    <img src={SNAImage25} className={styles.chatIcon} aria-hidden="true" />
                  </a>
                  <a href="https://www.imf.org/en/-/media/files/data/statistics/bmp7/draft-consolidated-bpm7-annotated-outline.pdf" target="_blank" rel="noopener noreferrer">
                    <img src={BPM7Image} className={styles.chatIcon} aria-hidden="true" />
                  </a>
                  <a href="https://www.imf.org/en/-/media/files/data/2019/2019-fsi-guide.pdf" target="_blank" rel="noopener noreferrer">
                    <img src={FSIImage} className={styles.chatIcon} aria-hidden="true" />
                  </a>
                  <a href="https://www.imf.org/external/pubs/ft/gfs/manual/2014/gfsfinal.pdf" target="_blank" rel="noopener noreferrer">
                    <img src={GFSImage} className={styles.chatIcon} aria-hidden="true" />
                  </a>
                </Stack>
                <h1 className={styles.chatEmptyStateTitle}>{ui?.chat_title ?? 'Talk2Manuals'}</h1>
                <h2 className={styles.chatEmptyStateSubtitle}>{ui?.chat_description ?? 'Talk to the Statistical Standards'}</h2>
                <Stack 
                horizontal 
                wrap 
                tokens={{ childrenGap: 10 }} 
                style={{ 
                  marginTop: '20px', 
                  justifyContent: 'center', 
                  flexWrap: 'wrap',
                  maxWidth: '100%',
                  gap: '10px',
                }}
              >
                <button className={styles.elegantButton} onClick={() => handleQuickQuestion("What does #SNA define for GDP?")}>
                  <span>What does <strong>#SNA</strong> define for GDP?</span>
                </button>
                <button className={styles.elegantButton} onClick={() => handleQuickQuestion("Explain financial accounts in #BPM?")}>
                  <span>Explain financial accounts in <strong>#BPM</strong></span>
                </button>
                <button className={styles.elegantButton} onClick={() => handleQuickQuestion("How does #FSI measure credit risk?")}>
                  <span>How does <strong>#FSI</strong> measure credit risk?</span>
                </button>
                <button className={styles.elegantButton} onClick={() => handleQuickQuestion("Define government deficit in #GFS")}>
                  <span>Define government deficit in <strong>#GFS</strong></span>
                </button>
              </Stack>
              <div style={{ textAlign: 'center', marginTop: '10px' }}>
                <a
                  style={{
                    color: '#0078d4',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px',
                  }}
                  onClick={() => setIsStatsChatModalOpen(true)}
                >
                  Disclaimer
                </a>
                <span style={{ margin: '0 8px', color: '#0078d4', fontSize: '14px' }}>·</span>
                <a
                  href="#"
                  style={{
                    color: '#0078d4',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px',
                  }}
                  onClick={handleContactSupportClick}
                >
                  Contact Support
                </a>
                {showSupportFallbackMessage && (
                  <div style={{ marginTop: '8px', color: '#605e5c', fontSize: '12px' }}>
                    Couldn't open your email app.
                    <button
                      type="button"
                      onClick={handleCopySupportEmail}
                      style={{
                        marginLeft: '6px',
                        color: '#0078d4',
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        fontSize: '12px'
                      }}
                    >
                      Copy support email
                    </button>
                    {supportEmailCopied && <span style={{ marginLeft: '6px' }}>Copied.</span>}
                  </div>
                )}
              </div>

              </Stack>
              
            ) : (
              <div className={styles.chatMessageStream} style={{ marginBottom: isLoading ? '40px' : '0px' }} role="log">
                {messages.map((answer, index) => (
                  <>
                    {answer.role === 'user' ? (
                      <div className={styles.chatMessageUser} tabIndex={0}>
                        <div className={styles.chatMessageUserMessage}>
                          {typeof answer.content === "string" && answer.content ? answer.content : Array.isArray(answer.content) ? <>{answer.content[0].text} <img className={styles.uploadedImageChat} src={answer.content[1].image_url.url} alt="Uploaded Preview" /></> : null}
                        </div>
                      </div>
                    ) : answer.role === 'assistant' ? (
                      <div className={styles.chatMessageGpt}>
                        {typeof answer.content === "string" && (() => {
                          const toolForAnswer = findNearestToolMessage(messages, index)
                          const hideCitationCount = isLoading && index === findLastAssistantIndex(messages)
                          return (
                            <Answer
                              answer={{
                                answer: answer.content,
                                citations: parseCitationFromMessage(toolForAnswer),
                                generated_chart: parsePlotFromMessage(toolForAnswer),
                                message_id: answer.id,
                                feedback: answer.feedback,
                                exec_results: execResults
                              }}
                              hideCitationCount={hideCitationCount}
                              onCitationClicked={c => onShowCitation(c)}
                              onExectResultClicked={() => onShowExecResult(answerId)}
                            />
                          )
                        })()}
                      </div>
                      //Original Message changed on 05/08/2025
 /*                   ) : answer.role === ERROR ? (
                      <div className={styles.chatMessageError}>
                        <Stack horizontal className={styles.chatMessageErrorContent}>
                          <ErrorCircleRegular className={styles.errorIcon} style={{ color: 'rgba(182, 52, 67, 1)' }} />
                          <span>Error</span>
                        </Stack>
                        <span className={styles.chatMessageErrorContent}>{typeof answer.content === "string" && answer.content}</span>
                      </div>
                    ) : null}*/

                  //Replaced by this new version Error message
                  ) : answer.role === ERROR ? (
                    (() => {
                      const isFilteredWarning =
                        typeof answer.content === 'string' && answer.content.includes('triggered a safety filter')
                      return (
                        <div className={isFilteredWarning ? styles.chatMessageFilteredNotice : styles.chatMessageError}>
                        {!isFilteredWarning && (
                          <Stack horizontal className={styles.chatMessageErrorContent}>
                            <ErrorCircleRegular
                              className={styles.errorIcon}
                              style={{ color: 'rgba(182, 52, 67, 1)' }}
                            />
                            <span>Error</span>
                          </Stack>
                        )}

                        {isFilteredWarning ? (
                          <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                            {/* Optional icon: if you want a calmer info icon */}
                            <Info16Regular style={{ color: '#0078d4', fontSize: '18px', minWidth: '18px', minHeight: '18px' }} />
                            <span>{typeof answer.content === "string" && answer.content}</span>
                          </Stack>
                        ) : (
                          <span className={styles.chatMessageErrorContent}>
                            {typeof answer.content === "string" && answer.content}
                          </span>
                        )}
                      </div>
                      )
                    })()
                  ) : null}
                  
                  </>
                ))}
                {showLoadingMessage && (
                  <>
                    <div className={styles.chatMessageGpt}>
                      <Answer
                        answer={{
                          answer: "Generating answer...",
                          citations: [],
                          generated_chart: null
                        }}
                        onCitationClicked={() => null}
                        onExectResultClicked={() => null}
                      />
                    </div>
                  </>
                )}
                <div ref={chatMessageStreamEnd} />
              </div>
            )}
            {!(isLoading && messages.length > 0) && (
            <Stack verticalAlign="center" style={{ gap: "10px", padding: "10px", width: "100%", alignItems: "center" }}>
              <DocumentDropdown
                documents={documents}
                documentOrder={documentNameMappingOrder}
                selectedDocuments={selectedDocuments}
                setSelectedDocuments={setSelectedDocuments}
                documentNameMapping={documentNameMapping}
                triggerLabel="Select a Standard"
                minimized={isDocSelectorMinimized}
                onMinimizedChange={setIsDocSelectorMinimized}
              />
            </Stack>
            )}
            
            <Dialog
              hidden={!isStatsChatModalOpen}
              onDismiss={() => setIsStatsChatModalOpen(false)}
              dialogContentProps={{
                type: DialogType.normal,
                title: 'Disclaimer'
              }}
              modalProps={{
                isBlocking: false,
                styles: { main: { maxWidth: 600 } }
              }}
            >
              <div>
                <p>
                  Talk2Manuals is an AI assistant that helps statisticians, economists, and data users
                  navigate international statistical manuals—such as the Balance of Payments Manual (BPM)
                  and the System of National Accounts (SNA). Its guidance is based on these manuals.
                </p>

                <p>
                  While every effort is made to ensure that responses are accurate, relevant, and consistent
                  with underlying manuals, the outputs are generated by artificial intelligence and may
                  occasionally contain inaccuracies, misinterpretations, or “hallucinations”. Users are
                  strongly encouraged to verify critical information against the official manuals and
                  authoritative sources before relying on it for analysis, reporting, or decision-making.
                  Information provided by Talk2Manuals does not represent the official position of the Fund.
                </p>

                <p>
                  The content delivered by Talk2Manuals is provided “as is” and “as available,” and every
                  effort is made to ensure—but not guarantee—its timeliness, accuracy, and completeness.
                  When errors are discovered, there is a concerted effort to correct them as appropriate and
                  feasible, but no responsibility is accepted for any consequences arising from reliance on
                  Talk2Manuals’ outputs.
                </p>
              </div>

              <div style={{ textAlign: 'right', marginTop: '20px' }}>
                <button
                  onClick={() => setIsStatsChatModalOpen(false)}
                  style={{
                    background: '#0078d4',
                    color: 'white',
                    padding: '8px 16px',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Close
                </button>
              </div>
            </Dialog>

          
            <Stack horizontal className={styles.chatInput}>
              {isLoading && messages.length > 0 && (
                <Stack
                  horizontal
                  className={styles.stopGeneratingContainer}
                  role="button"
                  aria-label="Stop generating"
                  tabIndex={0}
                  onClick={stopGenerating}
                  onKeyDown={(e: React.KeyboardEvent) => (e.key === 'Enter' || e.key === ' ' ? stopGenerating() : null)}>
                  <SquareRegular className={styles.stopGeneratingIcon} aria-hidden="true" />
                  <span className={styles.stopGeneratingText} aria-hidden="true">
                    Stop generating
                  </span>
                </Stack>
              )}
              <Stack>
                {appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured && (
                  <CommandBarButton
                    role="button"
                    styles={{
                      icon: {
                        color: '#FFFFFF'
                      },
                      iconDisabled: {
                        color: '#BDBDBD !important'
                      },
                      root: {
                        color: '#FFFFFF',
                        background:
                          'radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)'
                      },
                      rootDisabled: {
                        background: '#F0F0F0'
                      }
                    }}
                    className={styles.newChatIcon}
                    iconProps={{ iconName: 'Add' }}
                    //text="New Chat"  // This adds the text next to the icon
                    onClick={newChat}
                    disabled={disabledButton()}
                    aria-label="start a new chat button"
                  />
                )}
                <CommandBarButton
                  role="button"
                  styles={{
                    icon: {
                      color: '#FFFFFF'
                    },
                    iconDisabled: {
                      color: '#BDBDBD !important'
                    },
                    root: {
                      color: '#FFFFFF',
                      background:
                        'radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)'
                    },
                    rootDisabled: {
                      background: '#F0F0F0'
                    }
                  }}
                  className={
                    appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured
                      ? styles.clearChatBroom
                      : styles.clearChatBroomNoCosmos
                  }
                  iconProps={{ iconName: 'Broom' }}
                  onClick={
                    appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured
                      ? clearChat
                      : newChat
                  }
                  disabled={disabledButton()}
                  aria-label="clear chat button"
                />
                <Dialog
                  hidden={hideErrorDialog}
                  onDismiss={handleErrorDialogClose}
                  dialogContentProps={errorDialogContentProps}
                  modalProps={modalProps}></Dialog>
              </Stack>
              <QuestionInput
                clearOnSend
                placeholder="Type a new question..."
                disabled={isLoading}
                autoFocus={!isLoading && !isStatsChatModalOpen}
                onSend={(question, id) => {
                  appStateContext?.state.isCosmosDBAvailable?.cosmosDB
                    ? makeApiRequestWithCosmosDB(question, id)
                    : makeApiRequestWithoutCosmosDB(question, id)
                }}
                conversationId={
                  appStateContext?.state.currentChat?.id ? appStateContext?.state.currentChat?.id : undefined
                }
              />
            </Stack>
          </div>
          {/* Citation Panel */}
          {messages && messages.length > 0 && isCitationPanelOpen && activeCitation && (
            <Stack.Item className={styles.citationPanel} tabIndex={0} role="tabpanel" aria-label="Citations Panel">
              <Stack
                aria-label="Citations Panel Header Container"
                horizontal
                className={styles.citationPanelHeaderContainer}
                horizontalAlign="space-between"
                verticalAlign="center">
                <span aria-label="Citations" className={styles.citationPanelHeader}>
                  Citations
                </span>
                <IconButton
                  iconProps={{ iconName: 'Cancel' }}
                  aria-label="Close citations panel"
                  onClick={() => setIsCitationPanelOpen(false)}
                />
              </Stack>
              <h5
                className={styles.citationPanelTitle}
                tabIndex={0}
                title={
                  activeCitation.url && !activeCitation.url.includes('blob.core')
                    ? activeCitation.url
                    : activeCitation.title ?? ''
                }
                onClick={() => onViewSource(activeCitation)}>
                {activeCitation.title}
              </h5>
              <div tabIndex={0}>
                <ReactMarkdown
                  linkTarget="_blank"
                  className={styles.citationPanelContent}
                  //children={DOMPurify.sanitize(activeCitation.content, { ALLOWED_TAGS: XSSAllowTags })}
     		          children = {cleanup_string(activeCitation.content)}
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  components={stripLinksComponent}
                />
              </div>
            </Stack.Item>
          )}
          {messages && messages.length > 0 && isIntentsPanelOpen && (
            <Stack.Item className={styles.citationPanel} tabIndex={0} role="tabpanel" aria-label="Intents Panel">
              <Stack
                aria-label="Intents Panel Header Container"
                horizontal
                className={styles.citationPanelHeaderContainer}
                horizontalAlign="space-between"
                verticalAlign="center">
                <span aria-label="Intents" className={styles.citationPanelHeader}>
                  Intents
                </span>
                <IconButton
                  iconProps={{ iconName: 'Cancel' }}
                  aria-label="Close intents panel"
                  onClick={() => setIsIntentsPanelOpen(false)}
                />
              </Stack>
              <Stack horizontalAlign="space-between">
                {appStateContext?.state?.answerExecResult[answerId]?.map((execResult: ExecResults, index) => (
                  <Stack className={styles.exectResultList} verticalAlign="space-between">
                    <><span>Intent:</span> <p>{execResult.intent}</p></>
                    {execResult.search_query && <><span>Search Query:</span>
                      <pre>
                        {execResult.search_query}
                      </pre></>}
                    {execResult.search_result && <><span>Search Result:</span> <p>{execResult.search_result}</p></>}
                    {execResult.code_generated && <><span>Code Generated:</span>
                      <pre>
                        {execResult.code_generated}
                      </pre>
                    </>}
                  </Stack>
                ))}
              </Stack>
            </Stack.Item>
          )}
          {appStateContext?.state.isChatHistoryOpen &&
            appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured && <ChatHistoryPanel />}
        </Stack>
      )}
    </div>
  )
}

export default Chat
